<template>
    <div class="answers">
        <fieldset class="no-label">
            <input
                ref="textInput"
                v-model="answer"
                type="text"
                autocomplete="off"
            >
        </fieldset>
    </div>
</template>

<script>

export default {
    props: {
        controlName: {
            type: String,
            default: '',
        },
        userAnswer: {
            type: String,
            default: '',
        },
    },
    computed: {
        answer: {
            /**
             * Gets saved user answer
             *
             * @returns {string} User answer.
             */
            get() {
                return this.userAnswer;
            },

            /**
             * Emits update answer event
             */
            set() {
                this.$event.$emit('update-anwser', {
                    control: this.controlName,
                    answer: this.$refs.textInput.value,
                });
            },
        },
    },
};
</script>
